import React from "react";
import * as S from './OwnerDetailsMmtStyles';
import StarRatingMmt from "../StarRatingMmt/StarRatingMmt";

const OwnerDetailsMmt = ({
    data
}) => {
  const {
      img,
      name,
      ratingVal,
      label,
      subLabel
  } = data || {};

  return (
    <S.OwnerDetails>
      { img && <S.OwnerImage src={img}/> }
      <div>
          <S.LabelWrapper>
              { name && <S.Name>{name}</S.Name> }
              { label && <S.Label className="label">{label}</S.Label> }
              { ratingVal && <StarRatingMmt value={ratingVal} /> }
          </S.LabelWrapper>
          { subLabel && <S.SubLabel>{subLabel}</S.SubLabel> }
      </div>
    </S.OwnerDetails>
  );
};

export default OwnerDetailsMmt;